export default __webpack_public_path__ + "static/media/msline.612afb35.png";